import { forwardRef } from 'react';
import MuiCloseIcon from '@mui/icons-material/Close';
import type { SvgIconProps } from '@mui/material';

const CloseIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <MuiCloseIcon ref={ref} {...props} />
));

export default CloseIcon;
